/**
 * @file vat-form-utils.ts
 *
 * Pure helpers for the VAT & taxes form: derive the editable fields from the
 * loaded settings (with defaults) and build the partial patch to persist.
 */

import type { VatSettings } from '../../api/payments-types';
import type { VatFormFields } from './vat-form-types';

/**
 * Derives the form fields from the VAT settings, defaulting when absent.
 *
 * @param settings - The loaded VAT settings, or undefined.
 *
 * @returns The seed fields.
 */
export function deriveVatFields(settings?: VatSettings): VatFormFields {
  return {
    enabled: settings?.enabled ?? false,
    standardRate: settings?.standardRate ?? '',
    applyToShipping: settings?.applyToShipping ?? false,
  };
}

/**
 * Builds the VAT settings patch from the form fields, trimming the rate.
 *
 * @param fields - The current form fields.
 *
 * @returns The partial VAT settings to persist.
 */
export function buildVatPatch(fields: VatFormFields): Partial<VatSettings> {
  return {
    enabled: fields.enabled,
    standardRate: fields.standardRate.trim(),
    applyToShipping: fields.applyToShipping,
  };
}
